import React from 'react'
import * as S from './styles'

import Curiosity from '@/components/Curiosity'

import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { Slide, SliderSettings } from '@/types/components/Login'

interface InfoSliderProps {
  settings: SliderSettings
  slides: Array<Slide>
  controlsTop: string
  controlsLeft?: string
}

const InfoSlider = ({
  settings,
  slides,
  controlsTop,
  controlsLeft
}: InfoSliderProps) => {
  let slider: Slider

  return (
    <S.InfoSliderContainer
      controlsTop={controlsTop}
      controlsLeft={controlsLeft}
    >
      {/* @ts-expect-error check this */}
      <Slider ref={c => (slider = c)} {...settings}>
        {slides.map((obj, i) => {
          return (
            <Curiosity
              key={i}
              img={obj.img}
              title={obj.title}
              text={obj.text}
            />
          )
        })}
      </Slider>
      <div className="controls">
        <button
          id="btn_prev"
          onClick={() => {
            slider.slickPrev()
          }}
        >
          <span className="material-icons">arrow_back</span>
        </button>
        <button
          id="btn_next"
          onClick={() => {
            slider.slickNext()
          }}
        >
          <span className="material-icons">arrow_forward</span>
        </button>
      </div>
    </S.InfoSliderContainer>
  )
}

export default InfoSlider
